import { ProjectIssueType } from "@/libraries/bxp-web-stargate-client/src";

import {
    USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
    USER_SEGMENTATION_TEAM_TYPE_DESIGN,
    USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
    USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
    USER_SEGMENTATION_TEAM_TYPE_MARKETING,
    USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
    USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE,
    USER_SEGMENTATION_TEAM_TYPE_SALES,
    USER_SEGMENTATION_TEAM_TYPE_HR,
    USER_SEGMENTATION_TEAM_TYPE_LEGAL,
    USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE
} from "../../models/user-segmentation";

import messages from "./messages";

export const USER_SEGMENTATION_TEAM_TYPE_UNKNOWN = "unknown";

export interface IssueType {
    name: string;
    avatarId: number;
    id: string;
}

export interface Configuration {
    issueTypes: IssueType[];
    columns: string[];
}

export type ProjectConfig = {
    issueTypes: ProjectIssueType[];
    columns: string[];
    projectName: string;
};

const featureIssueType: IssueType = {
    name: messages.featureIssueTypeName.defaultMessage,
    avatarId: 10314,
    id: "1"
};
const taskIssueType: IssueType = {
    name: messages.taskIssueTypeName.defaultMessage,
    avatarId: 10318,
    id: "14"
};
const storyIssueType: IssueType = {
    name: messages.storyIssueTypeName.defaultMessage,
    avatarId: 10315,
    id: "3"
};
const assetIssueType: IssueType = {
    name: messages.assetIssueTypeName.defaultMessage,
    avatarId: 10309,
    id: "5"
};

const incidentIssueType: IssueType = {
    name: messages.incidentIssueTypeName.defaultMessage,
    avatarId: 10304,
    id: "9"
};
const serviceRequestIssueType: IssueType = {
    name: messages.serviceRequestIssueTypeName.defaultMessage,
    avatarId: 10308,
    id: "10"
};
const campaignIssueType: IssueType = {
    name: messages.campaignIssueTypeName.defaultMessage,
    avatarId: 10313,
    id: "12"
};
const softwareDevelopmentSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }, { ...storyIssueType }],
    columns: [
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.inReviewColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};
const projectManagementSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...featureIssueType }, { ...taskIssueType }],
    columns: [
        messages.ideaColumnName.defaultMessage,
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.inReviewColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};
const productManagementSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...featureIssueType }, { ...taskIssueType }],
    columns: [
        messages.ideaColumnName.defaultMessage,
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.testingColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};
const designSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }, { ...assetIssueType }],
    columns: [
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};
const itSupportSampleProjectConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType },
        { ...incidentIssueType },
        { ...serviceRequestIssueType }
    ],
    columns: [
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.waitingForCustomerColumnName.defaultMessage,
        messages.resolvedColumnName.defaultMessage
    ]
};

const marketingSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }, { ...campaignIssueType }],
    columns: [
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};

const otherPersonalSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }],
    columns: [
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};

export const defaultSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }],
    columns: [
        messages.todoColumnName.defaultMessage,
        messages.inProgressColumnName.defaultMessage,
        messages.inReviewColumnName.defaultMessage,
        messages.doneColumnName.defaultMessage
    ]
};

export const SampleProjectConfigurations: {
    [teamType: string]: Configuration;
} = {
    [USER_SEGMENTATION_TEAM_TYPE_SOFTWARE]:
        softwareDevelopmentSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT]:
        projectManagementSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT]:
        productManagementSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_DESIGN]: designSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT]:
        itSupportSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_MARKETING]:
        marketingSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL]:
        otherPersonalSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_OPERATIONS]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE]:
        defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_SALES]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_HR]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_LEGAL]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE]:
        defaultSampleProjectConfiguration
};

export const KANBAN_PROJECT_DEFAULTS = {
    projectKey: "SAM1",
    template: "KANBAN",
    defaultProjectName: messages.defaultKanbanProjectName
};

export const SCRUM_PROJECT_DEFAULTS = {
    projectKey: "SAM2",
    template: "SCRUM",
    defaultProjectName: messages.defaultScrumProjectName
};
